import React, { useCallback } from 'react';
import {
  shallowEqual, useDispatch,
  useSelector,
} from 'react-redux';
import classNames from 'classnames/bind';

// Utils
import { DETALIZATION_MODAL_COMMON } from 'constants/detalization';

// Components
import { Text } from '@beef/ui-kit';
import { DATE_PERIOD, DROPDOWN_LIST } from '../../../mock';
import { setDetalizationReportEndPeriod, setDetalizationReportStartPeriod } from '../../../../store/detalizationReport/actions';
import { PeriodSelection } from '../../../PeriodSelection';

// Styles
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const DatePicker = () => {
  const dispatch = useDispatch();
  const {
    isValid,
    startPeriod,
    endPeriod,
  } = useSelector(({ detalizationNew }) => ({
    isValid: detalizationNew.detalizationReport.isDataValid,
    startPeriod: detalizationNew.detalizationReport.startPeriod,
    endPeriod: detalizationNew.detalizationReport.endPeriod,
  }), shallowEqual);

  const onChangeStartDate = useCallback(
    (startDate) => {
      dispatch(setDetalizationReportStartPeriod(startDate));
    },
    [dispatch],
  );

  const onChangeEndDate = useCallback(
    (endDate) => {
      dispatch(setDetalizationReportEndPeriod(endDate));
    },
    [dispatch],
  );

  const onSetSelectedDateOption = useCallback(
    (entry) => {
      onChangeStartDate(DATE_PERIOD[entry]);
      onChangeEndDate(new Date());
    },
    [onChangeStartDate, onChangeEndDate],
  );

  return (
    <div className={cx('container')}>
      <div className={cx('content', { 'content--error': !isValid })}>
        <PeriodSelection
          isModal
          title={DETALIZATION_MODAL_COMMON.DETALIZATION_PERIOD}
          errorMessage={DETALIZATION_MODAL_COMMON.ERROR_DATE_MASSAGE}
          setStartPeriod={onChangeStartDate}
          setEndPeriod={onChangeEndDate}
          startPeriod={startPeriod}
          endPeriod={endPeriod}
          setPeriod={onSetSelectedDateOption}
          isValidPeriod={isValid}
          dropdown={DROPDOWN_LIST}
        />
        <div className={cx('description')}>
          <Text size="size5-r-l">{DETALIZATION_MODAL_COMMON.INFO_MASSAGE}</Text>
        </div>
      </div>
    </div>
  );
};
